import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, iif, debounceTime } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_ANAGRAFICA_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeAnagraficaListAction,
} from '../../data.action';
import { filler } from '../../../../../utils/utils';
import { selectAnagraficaList } from '../../data.selector';

const retrieveAnagraficaListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_ANAGRAFICA_LIST),
    debounceTime(20),
    map(({ payload }: any) => payload),
    tap(p => console.log(`[epic ${RETRIEVE_ANAGRAFICA_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true })),
        iif(
          () => body?.pageSize <= 100,
          of(setListConfigAction({ anagrafica: body })),
          EMPTY
        ),
        defer(() =>
          from(
            request({ path: `anagrafica/list`, method: httpMethods.POST, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }

              // lazy load
              if (body?.append) {
                const currentList = selectAnagraficaList(state)?.result;
                return {
                  total: p?.total,
                  result: [...(currentList ?? []), ...p?.result],
                };
              }

              return { total: p?.total, result: [...p?.result, ...filler] };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_ANAGRAFICA_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeAnagraficaListAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_ANAGRAFICA_LIST}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false }))
      );
    })
  );

export default retrieveAnagraficaListEpic;
